<template>
	<!-- 개선이력 -->
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001574')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col">
				<sf-card class="border-0 bg-transparent h-100">
					<!-- <template v-if="isLoaded">
						<template v-if="!isGlims"> -->
					<sf-data-table
						ref="dataTable"
						:pageUnit="historyPagingInfo.pageUnit"
						:totalSize="historyPagingInfo.totalSize"
						paging
						index
						:columns="columns"
						:rows="rows"
						fit="fit"
						:stripe="false"
						:selection="false"
						:excel="isButton_(scrId, 'EX')"
						@changedPage="changedPage"
						height="75vh"
					>
					</sf-data-table>
					<!-- </template>
					</template> -->
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' },
		isGlims: { type: Boolean, default: false }
	},
	data() {
		return {
			show: false,
			isLoaded: false,
			partNo: ''
		};
	},
	async created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.pprHistoryList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '100px',
					sortable: true,
					highlight: true,
					clickEvent: this.clickPartNo
				},
				{
					label: this.getMessage_('QWCC001034'), //ppr번호
					prop: 'pprNo',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001032'), //발생일자
					prop: 'occuDd',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001464'), //발생장소
					prop: '',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000074'), //불량수량
					prop: 'badQty',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC002059'), //제기일
					prop: 'pprsDd',
					minWidth: '99px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001094'), //진행상태
					prop: 'pgsStCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getPgsStPcCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001420'), //회신요구일
					prop: 'rplRqDd',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001749'), //대책상태
					prop: 'mdvState',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001748'), //Delay
					prop: 'delay',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001465'), //격리수량
					children: [
						{
							label: this.getMessage_('QWCC001465'), //격리수량
							prop: 'sprtQty',
							minWidth: '100px',
							sortable: false
						},
						{
							label: this.getMessage_('QWCC000073'), //검사수량
							prop: 'ckuQty',
							minWidth: '100px',
							sortable: false
						}
					]
				},
				{
					label: this.getMessage_('QWCC001467') + '1', //불량유형1
					prop: 'badTypeLgrpNm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001467') + '2', //불량유형2
					prop: 'badTypeMgrpNm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001467') + '3', //불량유형3
					prop: 'badTypeSgrpNm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001382'), //작성자
					prop: 'affrDspoNm1',
					minWidth: '100px',
					sortable: true
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async open(params) {
			//console.log(params);
			this.show = true;
			//console.log('open');
			await this.getPrtRptHisList();
			// if (params) {
			// 	this.partNo = params.partNo;
			// }
		},
		close(param) {
			if (param) this.$emit('Refresh');
			//this.setPopupInit_();
			this.show = false;
			this.isLoaded = false;
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setHistoryPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setHistoryPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.getPrtRptHisList();
		},
		getPrtRptHisList() {
			try {
				//ppr번호가 없을때
				const partNo = this.detailForm.partNo;
				const affrPrcsId = this.detailForm.affrPrcsId;
				//console.log('111>>>', partNo, affrPrcsId);
				this.getPrtRptHisList_({ partNo, affrPrcsId }); //부품코드로 부품그룹코드 조회 및 구분값에 따라서 조회쿼리 변경됨
			} catch (error) {
				console.error(error);
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
